export default __webpack_public_path__ + "static/media/pin-toolbar.cec79ec7.webp";